"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRecommendationsGamesGamePage = void 0;
var useCache_1 = require("../useCache");
var useQuery_1 = require("../useQuery");
var keys_1 = require("../keys");
var game_api_1 = require("@l2p/game-api");
var user_1 = require("../user");
var react_1 = require("react");
var geo_1 = require("../geo");
var currencies_1 = require("../currencies");
var CURRENT_GAME_SLUG = 'currentGameSLug';
var useRecommendationsGamesGamePage = function (_a) {
    var _b;
    var gameSlug = _a.gameSlug, gameProviderId = _a.gameProviderId, gameId = _a.gameId;
    var isAuth = (0, user_1.useIsAuthorized)();
    var _c = (0, useCache_1.useCache)(), getDataFromCache = _c.getDataFromCache, setDataToCache = _c.setDataToCache;
    var geoData = (0, geo_1.useGeo)().data;
    var currentCurrency = (0, currencies_1.useCurrentCurrency)();
    var _d = (0, useQuery_1.useQuery)({
        path: keys_1.GAMES_RECOMMENDATIONS,
        canRender: !!(isAuth && gameSlug && geoData && currentCurrency),
        payload: {
            recommendationType: game_api_1.UserRecommendationsEnum.Similar,
            country: (_b = geoData === null || geoData === void 0 ? void 0 : geoData.geoData) === null || _b === void 0 ? void 0 : _b.countryCode,
            gameId: gameId,
            gameProviderId: gameProviderId,
            currency: currentCurrency,
        },
    }), data = _d.data, error = _d.error, isLoading = _d.isLoading, isValidating = _d.isValidating, mutate = _d.mutate;
    (0, react_1.useEffect)(function () {
        var prevGameSlug = getDataFromCache(CURRENT_GAME_SLUG);
        if (!prevGameSlug || prevGameSlug !== gameSlug) {
            mutate();
            setDataToCache(CURRENT_GAME_SLUG, gameSlug);
        }
    }, [getDataFromCache, setDataToCache, gameSlug, mutate]);
    return (0, react_1.useMemo)(function () { return ({
        data: data === null || data === void 0 ? void 0 : data.data,
        isLoading: isLoading,
        isValidating: isValidating,
        error: error,
    }); }, [data === null || data === void 0 ? void 0 : data.data, isLoading, isValidating, error]);
};
exports.useRecommendationsGamesGamePage = useRecommendationsGamesGamePage;
